import { Injectable } from '@angular/core';

export type FeatureToggleName = keyof FeatureToggles;

export interface FeatureToggles {
  /**C UI: Ability to Notify Customers of Returns, Rejections and Notifications of Change of Direct Deposits
   * https://ultidev/browse/ULTI-266870 */
  enableAlertsAndNotifications: boolean;

  /**C UI: View Employee Pay Details https://ultidev/browse/ULTI-297539 */
  enableQuickActions: boolean;

  /**Feature toggle for follow up feature; hardcoded off for now.*/
  showPayInfoPrintButtonAndNotesColumn: boolean;

  /**Feature toggle for ACH reversal time zone; hardcoded off for now.*/
  achReversalCutOffESTTimeZone: boolean;

  /**C UI: Modify the "At a Glance" Widget to Reflect a Netted Collection
   * https://ultidev/browse/ULTI-341011
   */
  enableApiForNettedCollections: boolean;

  /** CUI: Fifteen Day Alerts **/
  enableFifteenDayAlertsAndNotifications: boolean;

  /** CUI: Default Pay Date **/
  enableDefaultPayDate: boolean;

  /** CUI: C UI: Ability for Customer to Initiate Cancel Pay Requests and Stop Check Payment Requests
   * https://ultidev/browse/ULTI-266855
   */
  enableStopPaymentRequest: boolean;

  /**
   * CUI: Enable Pendo Analytics Snippet
   * https://ultidev/browse/ULTI-392308
   */
  enablePendo: boolean;

  /** CUI: Preparing CUI for Other Products https://ultidev/browse/ULTI-385812*/
  enableHomeAlertsNotifications: boolean;

  /** CUI: Add Employee's New Account Information in the Notification and Alerts Widget https://ultidev/browse/ULTI-404171 */
  enableAlertDetailsNachaAuditInfo: boolean;

    /** CUI: C UI: Ability to have more specific access to the diferent resources inside employee pay tab
     * https://ultidev/browse/ULTI-404337
     */
  enableEEPDetailedWebAccessRights: boolean;

  /** CUI: Enables CUI unified navigation */
  enableCUIUnifiedNavigation: boolean;

  /** CUI: Switches Alerts Endpoints to new Target for Prenote Alerts */
  enablePrenoteAlertsNotifications: boolean;

  /** Employee Pay - PSG Alerts Notification UI, UX & Verbiage Enhancement https://ultidev/browse/PRO-149340 */
  eEPayPSGAlertUpdates: boolean;

  /** Provide instant visibility to Payrolls Stuck in Assembling to avoid negative customer experience & speedy handling
   * https://ultidev/browse/PRO-45625
   */
  enableEePayAssemblingStatus: boolean;

  /** Customer Communication for ACH Reversals/Stop Payments https://ultidev/browse/PRO-27175 */
  enableStopPaymentInfoBox: boolean;

  /** Employee Pay - Quick Actions - View Stale Dated Checks - https://ultidev/browse/PRO-155714 */
  enableStaleDatedChecks: boolean;

  /** Provide self service request via PSG and set for processing in SSP Payments & Prenote Queue
   * https://ultidev.ultimatesoftware.com/browse/PRO-486715 */
  enableSendPrenoteFile: boolean;

    /** Routing API calls through ultipro https://ultidev.ultimatesoftware.com/browse/PRO-508073 */
    enableUltiProExternalHandler: boolean;
}

@Injectable()
export class FeatureToggleService {

  private featureToggles: FeatureToggles;

  public init(toggles: FeatureToggles) {
    this.featureToggles = toggles;
  }

  public isFeatureEnabled(...features: FeatureToggleName[]): boolean {
    if (!features || !features.length) {
      return true;
    }
    return features.every(f => this.featureToggles[f]);
  }
}
